import { combineReducers } from 'redux';
import AuthReducer from 'modules/auth';
import ChartReducer from 'modules/charts';
import ExperimentalReducer from 'modules/experimental';
import ThreeDReducer from 'modules/threed';
import infographics from 'modules/infographics';
import ProjectReducer from 'modules/project';

const rootReducer = combineReducers({
  auth: AuthReducer,
  charts: ChartReducer,
  experimental: ExperimentalReducer,
  threed: ThreeDReducer,
  infographics,
  project: ProjectReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js